import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Container, Form, Button, Row, Col, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import StocCurentPickerModal from "../pickers/StocCurentPickerModal";

const ObInvForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);

  const [formData, setFormData] = useState({
    doc_no: "",
    doc_date: new Date().toISOString().split("T")[0],
    bxgestiune_id: "",
    angajat_id: "",
            valoare_totala: 0,
    details: [],
  });

  const [gestiuni, setGestiuni] = useState([]);
  const [angajati, setAngajati] = useState([]);

  // For the product picker
  const [pickerShow, setPickerShow] = useState(false);
  const [activeRowIndex, setActiveRowIndex] = useState(null);

  useEffect(() => {
    // Load lookups
    api.get("/bxgestiune/?limit=1000").then(res => setGestiuni(res.data.items || res.data)).catch(console.error);
    api.get("/angajati/").then(res => setAngajati(res.data)).catch(console.error);

    if (isEdit) {
      api.get(`/obinv/dare_folosinta/${id}`).then((res) => {
        setFormData({
          doc_no: res.data.doc_no || "",
          doc_date: res.data.doc_date || "",
          bxgestiune_id: res.data.bxgestiune_id || "",
          angajat_id: res.data.angajat_id || "",
          bxcomanda_id: res.data.bxcomanda_id || "",
          centrucost_id: res.data.centrucost_id || "",
          valoare_totala: res.data.valoare_totala || 0,
          details: res.data.details || [],
        });
      }).catch(console.error);
    }
  }, [id, isEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDetailChange = (index, field, value) => {
    const newDetails = [...formData.details];
    newDetails[index][field] = value;
    
    // Auto calculate valftva
    let total = 0;
    newDetails.forEach(d => {
        total += (parseFloat(d.qty) || 0) * (parseFloat(d.pret_magazie) || 0);
    });
    
    setFormData((prev) => ({ ...prev, details: newDetails, valoare_totala: total }));
  };

  const addDetail = () => {
    setFormData((prev) => ({
      ...prev,
      details: [
        ...prev.details,
        { bxpart_id: "", qty: 1, pret_magazie: 0 },
      ],
    }));
  };

  const removeDetail = (index) => {
    const newDetails = formData.details.filter((_, i) => i !== index);
    
    let total = 0;
    newDetails.forEach(d => {
        total += (parseFloat(d.qty) || 0) * (parseFloat(d.pret_magazie) || 0);
    });
    
    setFormData((prev) => ({ ...prev, details: newDetails, valoare_totala: total }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...formData };
    const fieldsToClean = ["bxgestiune_id", "angajat_id", ];
    fieldsToClean.forEach(f => {
      if (payload[f] === "") payload[f] = null;
    });

    try {
      if (isEdit) {
        await api.put(`/obinv/dare_folosinta/${id}`, payload);
        toast.success("Document actualizat!");
      } else {
        await api.post("/obinv/dare_folosinta/", payload);
        toast.success("Document creat!");
      }
      navigate("/obinv");
    } catch (error) {
      console.error(error);
      toast.error("Eroare la salvare!");
    }
  };

  return (
    <Container className="mt-4">
      <h2>{isEdit ? "Editare Dare în folosință" : "Adăugare Dare în folosință"}</h2>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Număr Document</Form.Label>
              <Form.Control type="text" name="doc_no" value={formData.doc_no} onChange={handleChange} required />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Data</Form.Label>
              <Form.Control type="date" name="doc_date" value={formData.doc_date} onChange={handleChange} required />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Gestiune</Form.Label>
              <Form.Select name="bxgestiune_id" value={formData.bxgestiune_id} onChange={handleChange} required>
                <option value="">-- Selectează Gestiune --</option>
                {gestiuni.map(g => <option key={g.id} value={g.id}>{g.bxcod} - {g.bxnume}</option>)}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Angajat</Form.Label>
              <Form.Select name="angajat_id" value={formData.angajat_id} onChange={handleChange} required>
                <option value="">-- Selectează Angajat --</option>
                {angajati.map(a => <option key={a.id} value={a.id}>{a.nume_prenume}</option>)}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <h4>Linii Obiecte de Inventar</h4>
        <Table bordered size="sm">
          <thead>
            <tr>
              <th>Obiect (Produs)</th>
              <th>Cantitate</th>
              <th>Preț Unitar</th>
              <th>Total</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {formData.details.map((detail, index) => (
              <tr key={index}>
                <td>
                  <Button 
                    variant="outline-secondary" 
                    size="sm"
                    onClick={() => {
                      if (!formData.bxgestiune_id) {
                        toast.warning("Selectează mai întâi o gestiune!");
                        return;
                      }
                      setActiveRowIndex(index);
                      setPickerShow(true);
                    }}
                  >
                    {detail.bxpart_id ? (detail.cod + " - " + detail.denumire) : "Alege Produs..."}
                  </Button>
                </td>
                <td>
                  <Form.Control
                    type="number" step="0.01"
                    value={detail.qty}
                    onChange={(e) => handleDetailChange(index, "qty", e.target.value)}
                    required
                  />
                </td>
                <td>
                  <Form.Control
                    type="number" step="0.01"
                    value={detail.pret_magazie}
                    onChange={(e) => handleDetailChange(index, "pret_magazie", e.target.value)}
                  />
                </td>
                <td>
                  {((parseFloat(detail.qty) || 0) * (parseFloat(detail.pret_magazie) || 0)).toFixed(2)}
                </td>
                <td>
                  <Button variant="danger" size="sm" onClick={() => removeDetail(index)}>Șterge</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Button variant="secondary" size="sm" onClick={addDetail} className="mb-3">
          + Adaugă Linie
        </Button>

        <Row className="mb-3">
          <Col md={4} className="ms-auto text-end">
            <h5>Valoare Totală: {formData.valoare_totala.toFixed(2)}</h5>
          </Col>
        </Row>

        <Button variant="primary" type="submit">Salvează</Button>
      </Form>

      {/* Modal pentru alegere produse din stoc curent */}
      <StocCurentPickerModal
        show={pickerShow}
        gestiuneId={formData.bxgestiune_id}
        onHide={() => {
          setPickerShow(false);
          setActiveRowIndex(null);
        }}
        onPick={(picked) => {
          if (activeRowIndex !== null) {
            const newDetails = [...formData.details];
            const raw = picked.raw;
            newDetails[activeRowIndex] = {
              ...newDetails[activeRowIndex],
              bxpart_id: picked.id,
              cod: raw.cod,
              denumire: raw.denumire,
              qty: 1, 
              pret_magazie: raw.pret_magazie || 0
            };
            
            // Auto calculate valftva
            let total = 0;
            newDetails.forEach(d => {
                total += (parseFloat(d.qty) || 0) * (parseFloat(d.pret_magazie) || 0);
            });
            
            setFormData((prev) => ({ ...prev, details: newDetails, valoare_totala: total }));
          }
        }}
      />
    </Container>
  );
};

export default ObInvForm;
